import React from "react";

export default function Logo({ size = 24, white = false, hideText = false }) {
  const textColor = white ? "#FFFFFF" : "#404040";
  return (
    <div
      data-testid="vg-logo"
      className="inline-flex items-center gap-2 select-none"
      style={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, fontSize: size, letterSpacing: "-0.01em" }}
    >
      <img
        src="/brand/logo.png"
        alt="ValutaGenio"
        width={Math.round(size * 1.4)}
        height={Math.round(size * 1.4)}
        style={{ display: "block", borderRadius: 8 }}
      />
      {!hideText && (
        <span>
          <span style={{ color: textColor }}>Valuta</span>
          <span style={{ color: "#B40101" }}>Genio</span>
        </span>
      )}
    </div>
  );
}
